export const SHIPPING_METHOD_CODE_QUERY_PARAM = 'shippingMethodCode';
export const FINISH_QUERY_PARAM = 'finish';
export const SHEEN_QUERY_PARAM = 'sheen';
export const ORDER_ID_QUERY_PARAM = 'orderId';
